// eslint-disable-next-line import/no-unresolved
import { SchemaModifier } from '../types';
import { generateExecutions } from '../utils';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';

const courseModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.product_name) {
    main['headline'] = content.product_name;
    main['name'] = content.product_name;
  }
  if (content?.degree) {
    main['educationalCredentialAwarded'] = content.degree;
  }
  if (content?.ects_points) {
    main['numberOfCredits'] = content.ects_points;
  }
  if (content?.learning_environment) {
    main['courseMode'] = (
      normalizeContent(content?.learning_environment, true) as string[]
    ).join(', ');
  }
  if (content?.location_text) {
    main['location'] = content.location_text;
  }
  if (content?.occasions) {
    main['hasCourseInstance'] = generateExecutions(
      content.occasions,
      content,
      'CourseInstance',
      state,
    );
  }
  if (content?.evento_id) {
    main['courseCode'] = content.evento_id;
  }
};

export default courseModifier;
